<div class="container-sm">

  <h1>Reset Password</h1>

  <p>We'll send an email with a link so you can enter a new password.</p>

  <form (ngSubmit)="onSubmit(f.form)" #f="ngForm" novalidate>

    <div class="form-group"  [class.has-error]="(emailInput.invalid) && ( f.submitted || emailInput.touched)">
      <label for="input-email">Email</label>
      <input type="email" class="form-control" id="input-email" name="email"
             [(ngModel)]="email"
             #emailInput="ngModel"
             [class.is-invalid]="f.submitted && emailInput.invalid"
             required email
      >
      <p *ngIf="f.hasError('required', 'email') && ( f.submitted || emailInput.touched)" class="invalid-feedback">You forgot to write your email.</p>
      <p *ngIf="f.hasError('email', 'email') && ( f.submitted || emailInput.touched)" class="invalid-feedback">This does not appear to be a valid email.</p>
    </div>


    <button type="submit" class="btn btn-lg btn-block btn-primary">Send</button>

  </form>

</div>
